import { Alert } from '@ps/isp-web-component-library';
import { usePrevious } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';

import {
  TXTWCL_Bonus_cash_has_been_removed_du_ELL,
  TXTWCL_Close,
  TXTWCL_Free_Bet_has_been_removed_due__ELL
} from './BonusCash.messages.json';

const BonusCash: React.FC = () => {
  const opportunities = useSelector(select.betSlip.opportunities);
  const [bonusCashMessageVisible, setBonusCashMessageVisible] = useState(false);
  const [freeBetMessageVisible, setFreeBetMessageVisible] = useState(false);
  const { values: formValues } = useFormState({ subscription: { values: true } });
  const { formatMessage } = useRegulatoryIntl();

  const hasBonusCashAppliedToMultiple = Object.entries(formValues).some(
    ([oppId, { bonusCash }]) => !oppId.startsWith('SINGLE') && bonusCash?.length > 0
  );

  const hasFreeBetAppliedToMultiple = Object.entries(formValues).some(
    ([oppId, { freeBet }]) => !oppId.startsWith('SINGLE') && freeBet?.length > 0
  );

  const numberOfMultiples = opportunities.MULTIPLE.length;
  const previousNumberOfMultiples = usePrevious(numberOfMultiples);

  useEffect(() => {
    if (hasBonusCashAppliedToMultiple && previousNumberOfMultiples !== numberOfMultiples) {
      setBonusCashMessageVisible(true);
    }
  }, [hasBonusCashAppliedToMultiple, numberOfMultiples, previousNumberOfMultiples]);

  useEffect(() => {
    if (hasFreeBetAppliedToMultiple && previousNumberOfMultiples !== numberOfMultiples) {
      setFreeBetMessageVisible(true);
    }
  }, [hasFreeBetAppliedToMultiple, numberOfMultiples, previousNumberOfMultiples]);

  let message = TXTWCL_Bonus_cash_has_been_removed_du_ELL;
  let dismissCallback = () => setBonusCashMessageVisible(false);

  if (freeBetMessageVisible) {
    message = TXTWCL_Free_Bet_has_been_removed_due__ELL;
    dismissCallback = () => setFreeBetMessageVisible(false);
  }

  if (!bonusCashMessageVisible && !freeBetMessageVisible) return null;

  return (
    <Alert
      level="promotion"
      variant="aggressive"
      title={formatMessage(message)}
      dismissLabel={formatMessage(TXTWCL_Close)}
      onDismiss={dismissCallback}
      isSquare
    />
  );
};

export default BonusCash;
